import { buildPitch, type JamConcept } from "@/content/jam";

/**
 * Map a rolled/saved Jam concept into starting Design-Doc section values.
 * Shared by the Docs "prefill from concept" flow and the Jam "Create Pitch" action.
 */
export function prefillFromConcept(concept: JamConcept): { title: string; values: Record<string, string> } {
  const pitch = buildPitch(concept);
  const firstSentence = pitch.split(/(?<=\.)\s/)[0] ?? pitch;
  const values: Record<string, string> = {};
  const set = (k: string, v?: string) => {
    if (v && v.trim()) values[k] = v.trim();
  };
  set("logline", firstSentence);
  set("concept", pitch);
  set("mood", [concept.theme, concept.emotion].filter(Boolean).join(", "));
  set("audience", concept.audience);
  set("platform", concept.platform);
  set("coreMechanics", concept.mechanic ? `Core mechanic: ${concept.mechanic}.` : "");
  set("visualAesthetic", concept.artStyle ? `A ${concept.artStyle.toLowerCase()} visual style.` : "");
  return { title: concept.title, values };
}
